module.exports = __webpack_public_path__ + "static/media/instagram-white.286f0b5f.svg";